/**
 * Строки витрины в двух языках — это и есть проверка «Текст +40 %» из макета.
 *
 * ПОЧЕМУ НЕМЕЦКИЙ, А НЕ «LOREM» И НЕ РАСТЯНУТАЯ РУССКАЯ СТРОКА. Так сделал дизайнер
 * (комментарий в макете: «+40 %: немецкие строки — реальная проверка длины, а не
 * абстрактный „lorem“»), и он прав: искусственно удлинённая строка растёт равномерно,
 * а настоящий перевод даёт то, что ломает вёрстку на самом деле — длинные составные
 * слова без пробелов («Leistungskatalog», «Stornierungsgrund») и подписи кнопок,
 * которые из одного слова становятся тремя.
 *
 * ОТКУДА ВЗЯТЫ СТРОКИ.
 * Все русские — из макета «Оболочка - этап 0.dc.html» дословно.
 * Немецкие из того же макета (объект T и массив navA в его скрипте): save, cancel,
 * cancelVisit, later, editPast, reschedule, noShow, needAction, all, book, checking,
 * подписи вкладок и все три полосы целиком.
 * Остальные немецкие строки — рабочий перевод ДЛЯ ПРОВЕРКИ ДЛИНЫ. Это не сдача
 * локализации: их читает переводчик перед первым немецким салоном. Отмечены ниже
 * пометкой «длина».
 */

export interface UiStrings {
  /* кнопки */
  readonly save: string
  readonly cancel: string
  readonly cancelVisit: string
  readonly later: string
  readonly editPast: string
  readonly editPastDenied: string
  readonly reschedule: string
  readonly noShow: string
  readonly book: string
  readonly saving: string
  readonly focusDemo: string
  readonly pressedDemo: string
  readonly disabledDemo: string

  /* поля */
  readonly phoneLabel: string
  readonly phoneHint: string
  readonly phoneError: string
  readonly phoneErrorLabel: string
  readonly phoneMaskedLabel: string
  readonly phoneMaskedSpoken: string
  readonly reveal: string
  readonly revealNote: string
  readonly reasonLabel: string
  readonly reasonClient: string
  readonly reasonSalon: string
  readonly consentSpoken: string
  readonly consentAds: string
  readonly serviceLabel: string
  readonly serviceValue: string

  /* чипы */
  readonly needAction: string
  readonly all: string
  readonly byType: string

  /* значки */
  readonly badgeConfirmed: string
  readonly badgePending: string
  readonly badgeInProgress: string
  readonly badgeCompleted: string
  readonly badgeNoShow: string
  readonly badgeFirstVisit: string
  readonly badgeRestricted: string

  /* счётчики */
  readonly notifications: string
  readonly visits: string

  /* подсказка */
  readonly tooltipText: string

  /* каркас загрузки */
  readonly checking: string
  readonly loadingClients: string

  /* пустое состояние */
  readonly emptyTitle: string
  readonly emptyText: string
  readonly emptyAction: string
  readonly emptyQuietTitle: string
  readonly emptyQuietText: string

  /* полосы */
  readonly offlineTitle: string
  readonly offlineText: string
  readonly offlineAction: string
  readonly impersonateTitle: string
  readonly impersonateText: string
  readonly impersonateAction: string
  readonly billingTitle: string
  readonly billingText: string
  readonly billingAction: string
}

export const RU: UiStrings = {
  save: "Сохранить",
  cancel: "Отмена",
  cancelVisit: "Отменить визит",
  later: "Позже",
  editPast: "Изменить прошедшую запись",
  editPastDenied: "Изменять прошедшие записи может только управляющий",
  reschedule: "Перенести",
  noShow: "Не пришёл",
  book: "Записать",
  saving: "Сохраняем…",
  focusDemo: "Фокус с клавиатуры",
  pressedDemo: "Нажато",
  disabledDemo: "Выключено",

  phoneLabel: "Телефон клиента",
  phoneHint: "Прощает 8, пробелы, скобки — приводит сам",
  phoneError: "Нужен номер целиком, с кодом страны: +7 916 123-45-67",
  phoneErrorLabel: "Ошибка у поля",
  phoneMaskedLabel: "Телефон скрыт правом",
  phoneMaskedSpoken: "Телефон клиента скрыт, видны код и две последние цифры",
  reveal: "Показать",
  revealNote: "Открытие записывается в журнал действий",
  reasonLabel: "Причина отмены",
  reasonClient: "Клиент — не пришёл",
  reasonSalon: "Салон — мастер заболел",
  consentSpoken: "Согласие на обработку данных получено устно",
  consentAds: "Согласие на рекламу — отдельно, по умолчанию выключено",
  serviceLabel: "Услуга",
  serviceValue: "Окрашивание в две ступени с тонированием",

  needAction: "Требуют действия",
  all: "Все",
  byType: "По типу",

  badgeConfirmed: "Подтверждена",
  badgePending: "Ожидает",
  badgeInProgress: "В работе",
  badgeCompleted: "Завершён",
  badgeNoShow: "Не пришёл",
  badgeFirstVisit: "Первый визит",
  badgeRestricted: "Ограничена онлайн-запись",

  notifications: "непрочитанных уведомления",
  visits: "визита в карточке",

  tooltipText:
    "Подсказка по наведению · появляется с задержкой 400 мс · не единственный способ получить сведения",

  checking: "Проверяем доступ…",
  loadingClients: "Загружаем список клиентов",

  emptyTitle: "Чтобы вести запись, добавьте хотя бы одного мастера",
  emptyText:
    "Записи появятся в журнале, как только у мастера будут услуги и смена. Первые три шага занимают 10 минут.",
  emptyAction: "Добавить мастера",
  emptyQuietTitle: "Салон ещё настраивается",
  emptyQuietText: "Как только владелец добавит мастеров и услуги, здесь появится расписание.",

  offlineTitle: "Нет связи",
  offlineText: "Показан день на 14:35, изменения сейчас не сохраняются",
  offlineAction: "Повторить",
  impersonateTitle: "Режим поддержки",
  impersonateText: "Вы работаете в кабинете «Барбершоп на Ленина» от имени Ирины",
  impersonateAction: "Выйти из режима",
  billingTitle: "Оплата просрочена",
  billingText: "Доступ ограничится 20 сентября. Напоминания клиентам продолжат уходить",
  billingAction: "Оплатить",
}

export const DE: UiStrings = {
  save: "Speichern",
  cancel: "Abbrechen",
  cancelVisit: "Termin stornieren",
  later: "Später erinnern",
  editPast: "Vergangenen Termin bearbeiten",
  /* длина */ editPastDenied: "Vergangene Termine darf nur die Geschäftsführung bearbeiten",
  reschedule: "Verschieben",
  noShow: "Nicht erschienen",
  book: "Termin eintragen",
  /* длина */ saving: "Wird gespeichert…",
  /* длина */ focusDemo: "Tastaturfokus",
  /* длина */ pressedDemo: "Gedrückt",
  /* длина */ disabledDemo: "Deaktiviert",

  /* длина */ phoneLabel: "Telefonnummer des Kunden",
  /* длина */ phoneHint: "Verzeiht 8, Leerzeichen und Klammern — normalisiert selbst",
  /* длина */ phoneError: "Vollständige Nummer mit Ländervorwahl nötig: +7 916 123-45-67",
  /* длина */ phoneErrorLabel: "Fehler am Eingabefeld",
  /* длина */ phoneMaskedLabel: "Telefonnummer durch Berechtigung verborgen",
  /* длина */ phoneMaskedSpoken:
    "Telefonnummer des Kunden verborgen, sichtbar sind Vorwahl und die letzten zwei Ziffern",
  /* длина */ reveal: "Anzeigen",
  /* длина */ revealNote: "Das Aufdecken wird im Aktionsprotokoll vermerkt",
  /* длина */ reasonLabel: "Stornierungsgrund",
  /* длина */ reasonClient: "Kunde — nicht erschienen",
  /* длина */ reasonSalon: "Salon — Mitarbeiter erkrankt",
  /* длина */ consentSpoken: "Einwilligung zur Datenverarbeitung wurde mündlich erteilt",
  /* длина */ consentAds: "Einwilligung für Werbung — separat, standardmäßig deaktiviert",
  /* длина */ serviceLabel: "Leistung",
  /* длина */ serviceValue: "Zweistufige Haarfärbung mit Tönung",

  needAction: "Handlung erforderlich",
  all: "Alle Ereignisse",
  /* длина */ byType: "Nach Ereignistyp",

  /* длина */ badgeConfirmed: "Bestätigt",
  /* длина */ badgePending: "Ausstehend",
  /* длина */ badgeInProgress: "In Arbeit",
  /* длина */ badgeCompleted: "Abgeschlossen",
  /* длина */ badgeNoShow: "Nicht erschienen",
  /* длина */ badgeFirstVisit: "Erster Besuch",
  /* длина */ badgeRestricted: "Online-Buchung eingeschränkt",

  /* длина */ notifications: "ungelesene Benachrichtigungen",
  /* длина */ visits: "Besuche in der Kundenkarte",

  /* длина */ tooltipText:
    "Hinweis beim Überfahren · erscheint mit 400 ms Verzögerung · nicht der einzige Weg zur Information",

  checking: "Zugriff wird geprüft…",
  /* длина */ loadingClients: "Kundenliste wird geladen",

  /* длина */ emptyTitle: "Um Termine zu führen, fügen Sie mindestens einen Mitarbeiter hinzu",
  /* длина */ emptyText:
    "Termine erscheinen im Terminkalender, sobald der Mitarbeitende Leistungen und eine Schicht hat. Die ersten drei Schritte dauern 10 Minuten.",
  /* длина */ emptyAction: "Mitarbeitenden hinzufügen",
  /* длина */ emptyQuietTitle: "Der Salon wird noch eingerichtet",
  /* длина */ emptyQuietText:
    "Sobald der Inhaber Mitarbeitende und Leistungen hinzufügt, erscheint hier der Dienstplan.",

  offlineTitle: "Keine Verbindung",
  offlineText:
    "Angezeigt wird der Tag vom 14:35, Änderungen werden derzeit nicht gespeichert",
  offlineAction: "Erneut versuchen",
  impersonateTitle: "Support-Modus",
  impersonateText: "Sie arbeiten im Konto „Barbershop an der Lenina“ im Namen von Irina",
  impersonateAction: "Modus verlassen",
  billingTitle: "Zahlung überfällig",
  billingText:
    "Der Zugang wird am 20. September eingeschränkt. Erinnerungen an Kunden werden weiterhin verschickt",
  billingAction: "Bezahlen",
}
